export default {
  defaultBezier: 'cubic-bezier(.29, .67, .51, .97)',
}
